export const GET_CHANNEL_DETAILS = "GET_CHANNEL_DETAILS"
export const GET_CHANNEL_DETAILS_SUCCESS = "GET_CHANNEL_DETAILS_SUCCESS"
export const GET_CHANNEL_DETAILS_FAIL = "GET_CHANNEL_DETAILS_FAIL"

export const UPDATE_CHANNEL_DETAILS = "UPDATE_CHANNEL_DETAILS"
export const UPDATE_CHANNEL_DETAILS_SUCCESS = "UPDATE_CHANNEL_DETAILS_SUCCESS"
export const UPDATE_CHANNEL_DETAILS_FAIL = "UPDATE_CHANNEL_DETAILS_FAIL"
export const CLEAR_CHANNEL_DETAILS = "CLEAR_CHANNEL_DETAILS"

export const CLEAR_UPDATE_CHANNEL_DETAILS = "CLEAR_UPDATE_CHANNEL_DETAILS"